import { motion } from 'framer-motion';
import SplitText from '../fx/SplitText';

/** Consistent animated header for in-app pages (title uses a split-text reveal). */
export default function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"
    >
      <div className="flex items-start gap-3">
        {Icon && (
          <motion.div
            initial={{ scale: 0.6, opacity: 0, rotate: -12 }}
            animate={{ scale: 1, opacity: 1, rotate: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 18, delay: 0.05 }}
            className="mt-0.5 inline-flex rounded-xl bg-brand-500/15 p-2.5"
          >
            <Icon className="h-6 w-6 text-brand-300" />
          </motion.div>
        )}
        <div>
          <SplitText
            as="h1"
            text={title}
            stagger={0.035}
            className="font-display text-2xl font-semibold tracking-tight sm:text-3xl"
          />
          {subtitle && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.25 }}
              className="mt-1 text-content-muted"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </motion.div>
  );
}
